import React from 'react';

interface IconHashtagProps {
  className?: string;
  size?: number;
  color?: string;
}

export const IconHashtag: React.FC<IconHashtagProps> = ({ className = '', size = 16, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M3.60691 14L4.08024 11.3333H1.41357L1.64691 10H4.31357L5.02024 6H2.35357L2.58691 4.66667H5.25357L5.72691 2H7.06024L6.58691 4.66667H10.5869L11.0602 2H12.3936L11.9202 4.66667H14.5869L14.3536 6H11.6869L10.9802 10H13.6469L13.4136 11.3333H10.7469L10.2736 14H8.94024L9.41357 11.3333H5.41357L4.94024 14H3.60691ZM6.35357 6L5.64691 10H9.64691L10.3536 6H6.35357Z" />
    </svg>
  );
};

export default IconHashtag;
